import { getCityFullName } from "./getCityFullName";

const CityItemInList = ({ city,  inputValue, setState, language}) => {
    inputValue=inputValue.trim().toLowerCase()
    let cityFullName = getCityFullName(city, language)
    let cityNameParts = []
    let currentIndex = 0
    
    while(currentIndex <= cityFullName.length) {
        let index = cityFullName.trim().toLowerCase().indexOf(inputValue, currentIndex)
        
        
        if(index === -1) {
            cityNameParts.push({
                text: cityFullName.slice(currentIndex),
                highlighted: false
            })
            
            break
        }
        
        cityNameParts.push({
            text: cityFullName.slice(currentIndex, index),
            highlighted: false
        })
        
        cityNameParts.push({
            text: cityFullName.slice(index, index + inputValue.length),
            highlighted: true
        })
        currentIndex = index + inputValue.length
    }
    
    // console.log(city)

    const handleCityClick = (e) => {
        setState((prev) => ({
            ...prev,
            city: city.city,
            district: city.district,
            area: city.area,
            cityFullName: cityFullName
        }));
    };
    
    return (
        <div className='text-2xs px-4 py-1 text-left cursor-pointer' style={{borderBottom: "1px solid rgba(163, 163, 163, 0.33)"}} onClick={handleCityClick}>
            {cityNameParts.map((part,index) => {
                if(part.highlighted) {
                    return <span key={index} className="text-green-600">{part.text}</span>
                }
                return <span key={index}>{part.text}</span>
            })}
        </div>
    );
};

export default CityItemInList;
